export default {
  // ========== Textos específicos de Competencias ==========
  writingLabel: 'Redacción',
  associateCompetence: 'Asociar {entity}',
  associateDescriptor: 'Asociar {entity}',
  insertMode: 'Insertar',
  createMode: 'Crear',
  insertOrCreateTooltip: 'Ingresar oración directamente o utilizar el modo de "creación"',
  clearSelection: '--- Limpiar selección ---',
  subOrderLabel: 'Sub orden',
  orderTooltip: 'Este perfil ya cuenta con una {entity} en este orden.',
  relationshipCreated: 'Relación entre {entity1} y {entity2} creada.',
  relationshipUpdated: 'Relación entre {entity1} y {entity2} actualizada.',
  deletedFromProfile: '{entity} eliminada del {profile}.',
  noRaBaseMessage: 'Esta {entity} no cuenta con ningún {raBase}.',
  deleteAssociationConfirm: '¿Está seguro de que desea eliminar la asociación de esta instancia de "{entity}"?',
  selectToAssociate: 'Seleccione los {entity} a asociar.',
  associate: 'Asociar',
  // Competence Sentence form fields
  action: 'Acción',
  object: 'Objeto',
  condition: 'Condición',
  context: 'Contexto',
  verb: 'Verbo',
  content: 'Contenido',
  // Información de ayuda
  informationTitle: 'Información',
  whatDoes: '¿Qué hace?',
  whatWillKnow: '¿Qué sabrá hacer?',
  actionToPerform: 'La acción a',
  perform: 'desempeñar',
  expressedInIndicative: 'Se expresa en',
  indicative: 'indicativo',
  indicativeExamples: '(diseña, comunica).',
  reflectsAction: 'Refleja una',
  assessableAction: 'acción factible de evaluar',
  observableAction: 'y observar en tiempo presente.',
  aboutWhat: 'Sobre Qué',
  aboutWhatDetail: 'realiza la acción (objeto).',
  whatWillAsk: '¿Qué le pediré que evalúe, maneje, analice, informe?',
  forWhat: '¿Para Qué?',
  attitudes: 'Actitudes (Competencias Transversales)',
  attitudesDetail: 'Se consideran en relación al objeto/contenido y a la acción a realizar.',
  inWhatContext: 'En Qué Contexto',
  contextDetail: '¿Qué medios, escenarios, situaciones, contextos normativos?',
  contextRelation: 'Se consideran en relación a la condición, objeto/contenido y a la acción a realizar.',
  // Taxonomía y verbos
  showTaxonomy: 'Mostrar {entity}',
  hideTaxonomy: 'Ocultar {entity}',
  selectTaxonomy: '--Seleccione Taxonomía--',
  customizeVerb: 'Personalizar',
  verbWithoutCognitiveLevel: 'Este verbo se guardará sin nivel cognitivo.',
  noVerbsMatch: 'No hay {entity} que coincidan con su búsqueda.',
  cognitiveLevel: 'Nivel cognitivo',
  // Mensajes de validación
  mustSelectVerb: 'Debe seleccionar un verbo.',
  contentCannotBeEmpty: 'El contenido no puede estar vacío.',
  conditionCannotBeEmpty: 'La condición no puede estar vacía.',
  contextCannotBeEmpty: 'El contexto no puede estar vacío.',
  // Perfil de Egreso y Competencias
  associateToProfile: 'Asociar {entity1} a {entity2}',
  definePositionInProfile: 'Definir posición de la {entity1} con respecto al {entity2}.',
  linkToAll: 'Vincular a todos ({count})',
  linkToAllTooltip: 'Vincula esta {competence} a los {profiles} de la tabla que aún no la tienen. Si hay una búsqueda, solo a los que coinciden. No incluye {profiles} cerrados.',
  linkToAllSaveFirst: 'Guarda primero la {competence} para vincularla a todos los {profiles}.',
  linkToAllConfirmTitle: '¿Vincular la {competence} a {count} {profiles}?',
  linkToAllConfirmText: 'Cada vínculo queda al final del orden de su {profile}.',
  linkToAllConfirmButton: 'Vincular',
  linkedToProfiles: '{competence} vinculada a {count} {profiles}.',
  notApplicable: '-- No aplica --',
  // Descriptores de Competencias
  programs: 'Programas',
  deleteDescriptorContentConfirm: '¿Está seguro de que desea eliminar el contenido del título descriptivo?',
  deleteDescriptorTitleConfirm: '¿Está seguro de que desea eliminar el título descriptivo?',
  deleteDescriptorWarning: 'Esta acción no se podrá revertir y se eliminarán los objetos referenciados en la parte inferior.',
  title: 'Título',
  // CapacityForm
  isInstitutional: 'Es una {entity} institucional',
  mustAddFaculty: 'Debe agregar la {faculty} del {profile}.',
}
